'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _unitaudit = require('./unitaudit.component');

var _unitaudit2 = _interopRequireDefault(_unitaudit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var unitauditModule = _angular2.default.module('unitaudit', [_angularUiRouter2.default]).component('unitaudit', _unitaudit2.default);

exports.default = unitauditModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/unitaudit/unitaudit.js